import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantSaleRoomDto } from './merchantSaleRoom.dto';
import { SaleUnitCartDto } from './saleUnitCart.dto';
import { SaleUnitCartStatusEnum } from './saleUnitCartStatus.enum';
import { SaleUnitTypeDto } from './saleUnitType.dto';
import {IsOptional} from "class-validator";

export class MerchantSaleUnitDto extends BaseDto {
  noPersons: number;
  minNoPersons: number;
  allowCombinations: boolean;
  allowBookings: boolean
  allowPOSTableService: boolean;
  allowOrderAtTable: boolean;

  @IsOptional()
  isFood?: boolean;

  @IsOptional()
  isWaste?: boolean;

  description: string;
  identifier: string;
  uniqueId: string;
  addableNoPersons: number;
  position: JSON;
  saleRoom: MerchantSaleRoomDto;
  merchant: MerchantDto;
  saleUnitType: SaleUnitTypeDto;
  saleUnitTypeId: number;
  saleRoomId?: number;
  saleUnitCarts?: SaleUnitCartDto[];
  status?: SaleUnitCartStatusEnum;
  sequence?: number;

  // UP-3994 - splits client side props
  splitTableCount?: number;
  hasSplitTables?: boolean;
}
